import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { useEffect, useState } from 'react';
import reportProblemDialog from '../../assets/reportProblemDialog.png';
import './reportProblem.scss';
import { REPORTISSUE_URL } from '../../constants';
import axios from '../../datasource/axios';
import Spinner from '../../components/shared/spinner.jsx';
import { hideLoader } from '../../datasource/msal';
import { Dialog } from 'primereact/dialog';

export const ReportProblem = (props: any) => {
    const [issueType, setIssueType] = useState<any>(null);
    const [reportProblemComment, setReportProblemComment] = useState('');
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [successvisible, setSuccessVisible] = useState(false);
    const [failvisible, setFailVisible] = useState(false);
    const [number, setNumber] = useState('');
    const [count, setCount] = useState(1);
    const [message, setMessage] = useState("Unable to create a ticket, please click on Ok to try again.");

    const setSuccessdialogvisibility = () => {
        if (!successvisible) return; setSuccessVisible(false);
        props.handleCallback(false);
    }

    const setFaildialogvisibility = () => {
        if (count < 3) {
            if (count == 2) {
                setMessage("We are having issues creating ticket, Please open ticket manually via AskNow or Please try again later.");
            } else {
                Submit();
            }
            setCount(count + 1);
        }
        else {
            if (!failvisible) return; setFailVisible(false);
            props.handleCallback(false);
        }
    }

    const headerSuccessElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Success</span>
        </div>
    );

    const footerSuccessContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={setSuccessdialogvisibility} autoFocus style={{ borderRadius: '12px', backgroundColor: '#3299FF', color: 'white' }} />
        </div>
    );

    const headerFailElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Fail</span>
        </div>
    );

    const footerFailContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={setFaildialogvisibility} autoFocus style={{ borderRadius: '12px', backgroundColor: '#3299FF', color: 'white' }} />
        </div>
    );

    const onIssueTypeChange = (e: { value: any }) => {
        setIssueType(e.value);
    };

    useEffect(() => {
        const isFormValid =
            issueType !== null &&
            reportProblemComment !== '';
        setEnableSubmit(isFormValid);
    }, [reportProblemComment, issueType]);

    const Submit = async () => {
        let BASE_URL =  process.env.REACT_APP_API_URI;
        let url = BASE_URL + REPORTISSUE_URL + "?description=" + reportProblemComment + '&shortdescription=' + issueType.name + '&type=' + 'issue';
        const res:any = await new Promise((resolve, reject) => {
          try {
            setShowLoader(true);
             axios
              .postRequest(url)
              .then((res: any) => {
                hideLoader();
                setShowLoader(false);
                resolve(res);
              })
              .catch((err: any) => {
                hideLoader();
                setShowLoader(false);
                resolve(err);
              });
          } catch (error) {
            hideLoader();
            setShowLoader(false);
            reject(error);
          }
        });

        if (res.status == "Success") {
            setNumber(res.data);
            setSuccessVisible(true);
        }
        else{
            setFailVisible(true);
        }
    };

    return (
        <div>
            <h5 className="mb-3" style={{ fontSize: '24px', fontWeight: '600' }}>
                {/* <img src={reportProblemDialog} alt="Report a Problem" className="pe-2" /> */}
                 Report a problem
            </h5>
            <Divider />

            {/* <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
                User Details
            </h5> */}

            {/* <div className="row mt-3">
                <div className="col-md-6">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Name</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {props.username}
                    </p>
                </div>
                <div className="col-md-6">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Oracle ID</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {props.userid}
                    </p>
                </div>
            </div>

            <Divider /> */}

            <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
                Issue Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-8">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Issue Type</h5>
                    <Dropdown
                        value={issueType}
                        options={props.issueTypes}
                        onChange={onIssueTypeChange}
                        optionLabel="name"
                        placeholder="Select Issue Type"
                        className="w-100"
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Comment</h5>
                    <InputTextarea
                        className="w-100"
                        value={reportProblemComment}
                        onChange={(e) => setReportProblemComment(e.target.value)}
                        rows={5}
                        maxLength={4000}
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>
            <div className="reportProblemcharLimit">4,000 Character Limit</div>
            <div>
                <Button
                    label="Submit"
                    onClick={Submit}
                    disabled={!enableSubmit}
                    className="p-button ps-5 pe-5 float-end mt-3 mb-3"
                    style={{ borderRadius: '12px', backgroundColor: '#3299FF', color: 'white' }}
                />
            </div>
            <div>
                {showLoader && (
                    <div className="divSpinner">
                        <Spinner />
                    </div>
                )}

            </div>
            <Dialog visible={successvisible} modal header={headerSuccessElement} footer={footerSuccessContent} style={{ width: '30rem' }} onHide={setSuccessdialogvisibility} closable={false}>
                <p className="m-0">
                    Thank you for reaching out, We will address your concern as soon as possible. Here's your ticket number for your reference <b>{number}</b>
                </p>
            </Dialog>
            <Dialog visible={failvisible} modal header={headerFailElement} footer={footerFailContent} style={{ width: '30rem' }} onHide={setFaildialogvisibility} closable={false}>
                <p className="m-0">
                    {message}
                </p>
            </Dialog>
        </div>
    );
};
